<template>
    <!-- BEGIN Customers Table-->
    <div class="container-fluid customers-table">
        <!--<span>
              <strong>suggestions :</strong>
          </span>
        <span id="overlay-suggestions"></span>
        <br>-->
        <div class="search-results m-t-20">
            <!--<p class="bold">Pages Search Results</p>-->
            <div class="row">
                <div class="col-md-12">
                    <!-- START PANEL -->
                    <div class="panel panel-transparent">
                        <div class="panel-body">
                            <div class="table-responsive">
                                <table class="table table-hover table-condensed table-detailed search-table"
                                       id="detailedTable">
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th>Entreprise</th>
                                        <th>RP</th>
                                        <th>Contrat</th>
                                        <th>Gestionnaire</th>
                                        <th>Options</th>
                                        <th>Dossier</th>
                                        <th>État</th>
                                        <th>Détail</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <template v-for="n in 5">
                                        <item @click="showDetails = index" :index="index" :customer="customer"
                                              :show-details="showDetails === index" :key="n">
                                        </item>
                                        <template v-if="showDetails === index">
                                            <item-details :customer="customer" :index="index"
                                                          :key="index + n"></item-details>
                                        </template>
                                    </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <!-- Pagination -->
                        <div class="pagination p12">
                            <ul>
                                <li>Previous</li>
                                <li class="is-active">1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>Next</li>
                            </ul>
                        </div>
                        <!-- END PANEL -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- END Customers Table !-->
</template>

<style lang="scss" scoped>
    .customers-table {
        padding: 0;
    }

    .panel-body {
        min-width: 600px;
        padding: 0;
    }

    .search-table {
        th {
            width: auto;
            &:first-child {
                width: 10px;
            }
            &:nth-child(6) {
                width: 120px;
            }
            &:nth-child(7) {
                width: 130px;
            }
            &:last-child {
                width: 113px;
            }
        }
    }

    .pagination {
        padding: 0;
        float: right;
    }

    .pagination ul {
        margin: 0;
        padding: 0;
        list-style-type: none;
    }

    .pagination li {
        display: inline-block;
        padding: 5px 18px;
        color: #222;
    }

    .p12 li:first-of-type, .p12 li:last-of-type, .p12 .is-active {
        background-color: #fb557a;
        color: #fff;
        border-radius: 3px;
    }
</style>


<script type="text/babel">
    import Item from './Item'

    export default {
        data () {
            return {
                showDetails: null
            }
        },
        components: {
            Item
        },
        props: ['customers']
    }
</script>




// WEBPACK FOOTER //
// client/components/DomiciliationContractsList/DomiciliationContractsTable.vue